/*
 * Toggle Class fuctionality
 */

export default {
	 
	beforeMount(el, binding) {
		const targetId = binding.value.targetId || false;
		const classList = binding.value.class
			? binding.value.class.split(' ')
			: false;

		// Setup toggle class functionality
		 
		el.toggleClass = () => {
			const target = document.getElementById(targetId);

			if (target && classList) {
				classList.forEach((item) => {
					target.classList.toggle(item);
				});
			}
		};

		// Attach the click event to the element
		el.addEventListener(
			'click',
			() => {
				el.toggleClass();
			},
		);
	},
	 
	unmounted(el) {
		el.removeEventListener(
			'click',
			el.toggleClass,
		);
	},
};
